import type { StaffAvailability, TimeRange } from "@/types/appointments/api-types/availability-types";

import { isoDate, isoTime } from "@/lib/utils";

import { DataCard } from "./data-card";
import { type IntlShape, useIntl } from "react-intl";

const ranges = (intl: IntlShape, times: TimeRange[]) =>
  intl.formatList(
    times.map((t) => intl.formatDateTimeRange(isoTime(t.start_time), isoTime(t.end_time), { format: "clock" })),
    { type: "unit" },
  );

export function FreeTimeCard({ date, stylists }: { date: string; stylists: StaffAvailability[] }) {
  const intl = useIntl();
  const working = stylists.length === 1 ? "1 stylist working" : `${stylists.length} stylists working`;

  return (
    <DataCard summary={`${intl.formatDate(isoDate(date), { format: "day" })} · ${working}`}>
      {stylists.length === 0 && <p className="text-muted-foreground">Nobody's working.</p>}
      {stylists.map((stylist) => (
        <div key={stylist.staff_id} className="flex flex-col gap-0.5">
          <p className="font-medium">{stylist.staff_name}</p>
          <p>Hours {ranges(intl, stylist.working_hours)}</p>
          <p>{stylist.available_slots.length ? `Free ${ranges(intl, stylist.available_slots)}` : "Fully booked"}</p>
        </div>
      ))}
    </DataCard>
  );
}
